export const BASE = "BASE";
export const QUOTES = "QUOTES";
export const SETTINGS = "SETTINGS";
export const SITE_INFO = "SITE_INFO";
export const CREDENTIALS = "CREDENTIALS";
export const ATTENDANCE_STATUS = "ATTENDANCE_STATUS";
